import Text from './_text.js'
import FlexPane from './_flex-pane.js'
import ConfigurableBorder from './_configurable-border.js'
import Image from './_image.js'
import ProgressBar from './_progress-bar.js'

export default {
  name: 'InProgressBonuses',
  values: {
    noBonusesLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
        container: {
          padding: '40px 0',
        },
      },
    },
    bonusList: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '8px 0 0',
        },
      },
    },
    bonusContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '16px',
        style: {
          flexDirection: 'column',
          padding: '8px',
          borderStyle: 'none none solid none',
          borderWidth: '1px',
        },
      },
      style: {
        $mixin: [
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
    },
    bonusHeader: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    bonusNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    bonusPriceLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'right',
        },
      },
    },
    bonusNameLabel: {
      configSet: Text,
      configValues: {},
    },
    prewagerIcon: {
      configSet: Image,
      configValues: {
        src: 'prewager',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    cashIcon: {
      configSet: Image,
      configValues: {
        src: 'cash',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    freeBetIcon: {
      configSet: Image,
      configValues: {
        src: 'freebet-filled',
        style: {
          minWidth: '16px',
          minHeight: '16px',
        },
      },
    },
    bonusDescription: {
      configSet: Text,
      configValues: {},
    },
    stepsList: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
          padding: '0 8px',
        },
      },
    },
    stepContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    stepSubContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          padding: '0 0 7px',
          flexDirection: 'column',
          _desktop_flexDirection: 'row',
        },
      },
    },
    stepSubContainerBorder: {
      borderWidth: '0 0 1px 0',
      borderStyle: 'solid',
      $mixin: [
        {
          configSet: ConfigurableBorder,
        },
      ],
    },
    progressContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '8px',
        style: {
          flexDirection: 'column',
        },
      },
    },
    stepNameContainer: {
      configSet: FlexPane,
      configValues: {
        itemSpacing: '4px',
        style: {
          justifyContent: 'space-between',
        },
      },
    },
    stepNumber: {
      configSet: FlexPane,
      configValues: {
        style: {
          flexGrow: 0,
          minWidth: '16px',
          maxWidth: '16px',
          minHeight: '16px',
          maxHeight: '16px',
          borderWidth: '1px',
          borderStyle: 'solid',
        },
      },
      style: {
        $mixin: [
          {
            configSet: ConfigurableBorder,
          },
        ],
      },
    },
    stepNumberLabel: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'center',
        },
      },
    },
    stepNameLabel: {
      configSet: Text,
      configValues: {
        truncate: true,
        ellipsisOnLineNumber: 2,
      },
    },
    stepStatus: {
      configSet: Text,
      configValues: {
        style: {
          textAlign: 'right',
          textTransform: 'uppercase',
        },
      },
    },
    stepDescription: {
      configSet: Text,
      configValues: {
        container: {
          _desktop_width: '60%',
          _desktop_flexGrow: '0',
        },
      },
    },
    stepInfo: {
      configSet: Text,
      configValues: {
        container: {
          padding: '2px 0 0 0',
        },
      },
    },
    progressBar: {
      configSet: ProgressBar,
      configValues: {
        isRangeLabelRatio: false,
        rangeLabel: {
          style: {
            textAlign: 'left',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
